import { createAction, props } from '@ngrx/store';

// Connect
export const livespaceConnect = createAction(
  '[Livespace] Connect',
  props<{ subdomain: string; api_key: string; api_secret: string }>(),
);
export const livespaceConnectSuccess = createAction(
  '[Livespace] Connect Success',
  props<{ user: any }>(),
);
export const livespaceConnectFailure = createAction(
  '[Livespace] Connect Failure',
  props<{ error: string }>(),
);

// Disconnect
export const livespaceDisconnect = createAction('[Livespace] Disconnect');
export const livespaceDisconnectSuccess = createAction(
  '[Livespace] Disconnect Success',
  props<{ user: any }>(),
);
export const livespaceDisconnectFailure = createAction(
  '[Livespace] Disconnect Failure',
  props<{ error: string }>(),
);

// Get Contact (by search_id — mirrors getHubspotContact)
export const getLivespaceContact = createAction(
  '[Livespace] Get Livespace Contact',
  props<{ search_id: number }>(),
);
export const getLivespaceContactSuccess = createAction(
  '[Livespace] Get Livespace Contact Success',
  props<{ livespace_contact: any }>(),
);
export const getLivespaceContactFailure = createAction(
  '[Livespace] Get Livespace Contact Failure',
  props<{ error: any }>(),
);

// Get Companies
export const getLivespaceCompanies = createAction(
  '[Livespace] Get Livespace Companies',
  props<{ search_id: number }>(),
);
export const getLivespaceCompaniesSuccess = createAction(
  '[Livespace] Get Livespace Companies Success',
  props<{ livespace_companies: any }>(),
);
export const getLivespaceCompaniesFailure = createAction(
  '[Livespace] Get Livespace Companies Failure',
  props<{ error: any }>(),
);

// Get Processes (equivalent to HubSpot pipelines)
export const getLivespaceProcesses = createAction(
  '[Livespace] Get Livespace Processes',
  props<{ search_id: number }>(),
);
export const getLivespaceProcessesSuccess = createAction(
  '[Livespace] Get Livespace Processes Success',
  props<{ livespace_processes: any }>(),
);
export const getLivespaceProcessesFailure = createAction(
  '[Livespace] Get Livespace Processes Failure',
  props<{ error: any }>(),
);

// New Contact
export const livespaceNewContact = createAction(
  '[Livespace] New Contact',
  props<{
    user_id: any;
    first_name: string;
    last_name: string;
    email: string;
    phone: string;
    emails?: string[];
    phones?: string[];
    company_name: string;
    job_title: string;
    social_media?: { linkedin?: string; twitter?: string; facebook?: string };
    // Full company details extracted from the report, used to populate a
    // newly-created Livespace company (instead of a name-only auto-create).
    company_details?: {
      domain?: string;
      phone?: string;
      email?: string;
      city?: string;
      state?: string;
      country?: string;
      street?: string;
      postcode?: string;
      linkedin?: string;
      twitter?: string;
      facebook?: string;
    };
  }>(),
);
export const livespaceNewContactSuccess = createAction(
  '[Livespace] New Contact Success',
  props<{ livespace_new_contact: any }>(),
);
export const livespaceNewContactFailure = createAction(
  '[Livespace] New Contact Failure',
  props<{ error: string }>(),
);

// New Company
export const livespaceNewCompany = createAction(
  '[Livespace] New Company',
  props<{
    user_id: any;
    company_name: string;
    company_domain: string;
    company_phone: string;
    company_city: string;
    company_state: string;
    company_email?: string;
    company_linkedin?: string;
    company_twitter?: string;
    company_facebook?: string;
    company_client_status?: string;
  }>(),
);
export const livespaceNewCompanySuccess = createAction(
  '[Livespace] New Company Success',
  props<{ livespace_new_company: any }>(),
);
export const livespaceNewCompanyFailure = createAction(
  '[Livespace] New Company Failure',
  props<{ error: string }>(),
);

// Update Contact
export const livespaceUpdateContact = createAction(
  '[Livespace] Update Contact',
  props<{
    user_id: any;
    contact_id: string;
    first_name: string;
    last_name: string;
    email: string;
    phone: string;
    emails?: string[];
    phones?: string[];
    company_name: string;
    job_title: string;
    social_media?: { linkedin?: string; twitter?: string; facebook?: string };
  }>(),
);
export const livespaceUpdateContactSuccess = createAction(
  '[Livespace] Update Contact Success',
  props<{ livespace_updated_contact: any }>(),
);
export const livespaceUpdateContactFailure = createAction(
  '[Livespace] Update Contact Failure',
  props<{ error: string }>(),
);

// Update Company
export const livespaceUpdateCompany = createAction(
  '[Livespace] Update Company',
  props<{
    user_id: any;
    company_id: string;
    company_name: string;
    company_domain: string;
    company_phone: string;
    company_city: string;
    company_state: string;
    company_email?: string;
    company_linkedin?: string;
    company_twitter?: string;
    company_facebook?: string;
  }>(),
);
export const livespaceUpdateCompanySuccess = createAction(
  '[Livespace] Update Company Success',
  props<{ livespace_updated_company: any }>(),
);
export const livespaceUpdateCompanyFailure = createAction(
  '[Livespace] Update Company Failure',
  props<{ error: string }>(),
);

// Get Deals
export const getLivespaceDeals = createAction(
  '[Livespace] Get Deals',
  props<{ contact_id?: string; company_id?: string }>(),
);
export const getLivespaceDealsSuccess = createAction(
  '[Livespace] Get Deals Success',
  props<{ livespace_deals: any }>(),
);
export const getLivespaceDealsFailure = createAction(
  '[Livespace] Get Deals Failure',
  props<{ error: any }>(),
);

// New Deal
export const livespaceNewDeal = createAction(
  '[Livespace] New Deal',
  props<{
    user_id: any;
    deal_name: string;
    company_name: string;
    contact_name: string;
    process_id?: string;
    date_end?: string;
    source_id?: string;
    owner_id?: string;
    visibility?: string;
    category_name?: string;
    product_id?: string;
    price?: string;
  }>(),
);
export const livespaceNewDealSuccess = createAction(
  '[Livespace] New Deal Success',
  props<{ livespace_new_deal: any }>(),
);
export const livespaceNewDealFailure = createAction(
  '[Livespace] New Deal Failure',
  props<{ error: string }>(),
);

// Get Deal Sources
export const getLivespaceSources = createAction('[Livespace] Get Sources');
export const getLivespaceSourcesSuccess = createAction(
  '[Livespace] Get Sources Success',
  props<{ livespace_sources: any }>(),
);
export const getLivespaceSourcesFailure = createAction(
  '[Livespace] Get Sources Failure',
  props<{ error: any }>(),
);

// Get Users (team members)
export const getLivespaceUsers = createAction('[Livespace] Get Users');
export const getLivespaceUsersSuccess = createAction(
  '[Livespace] Get Users Success',
  props<{ livespace_users: any }>(),
);
export const getLivespaceUsersFailure = createAction(
  '[Livespace] Get Users Failure',
  props<{ error: any }>(),
);

// Get Products
export const getLivespaceProducts = createAction('[Livespace] Get Products');
export const getLivespaceProductsSuccess = createAction(
  '[Livespace] Get Products Success',
  props<{ livespace_products: any }>(),
);
export const getLivespaceProductsFailure = createAction(
  '[Livespace] Get Products Failure',
  props<{ error: any }>(),
);

// Get Current User
export const getLivespaceCurrentUser = createAction(
  '[Livespace] Get Current User',
);
export const getLivespaceCurrentUserSuccess = createAction(
  '[Livespace] Get Current User Success',
  props<{ livespace_current_user: any }>(),
);
export const getLivespaceCurrentUserFailure = createAction(
  '[Livespace] Get Current User Failure',
  props<{ error: any }>(),
);

// Clear
export const clearLivespace = createAction('[Livespace] Clear');
